import { render, staticRenderFns } from "./ProfileAboutusView.vue?vue&type=template&id=443a332c"
import script from "./ProfileAboutusView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileAboutusView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports